module.exports = __webpack_public_path__ + "img/landing-banner-2@2x.90a5aa51.jpg";